/*
 * Date: 2020-07-28 15:12:40
 * LastEditors: Mosuzi
 * LastEditTime: 2020-08-05 22:07:14
 * Description: 个人中心国际化
 * Author: Mosuzi
 */
export default {
  personalCenter: {
    help: '帮助与反馈',
    setting: '设置',
    signature: '填写个人简介',
    title: '我的'
  },
  help: {
    commonIssue: '常见问题',
    tryoutDefinesysCloud: '如何试用得帆云？',
    inviteColleague: '如何邀请同事加入组织？',
    createApplication: '如何创建应用？',
    increaseUses: '如何提高版本用量？',
    cannotReceiveVerificationCode: '为什么收不到短信或邮件验证码？',
    retrieveData: '数据删除后还能找回吗？',
    exportData: '数据可以导出吗？',
    applyForBilling: '如何申请开票？',
    feedback: '反馈建议',
    howAcceptNotice: '如何通过短信接收得帆云消息提醒？',
    howBindEmail: '如何绑定邮箱？',
    howBindWeChatNotice: '如何绑定微信公众号接受消息提醒？'
  },
  tenant: {
    title: '切换组织',
    oufOfDate: '到期'
  },
  profile: {
    title: '个人资料',
    avatar: '头像',
    name: '姓名',
    gender: '性别',
    birthday: '生日',
    position: '职位',
    corporation: '公司',
    signature: '个人简介',
    avatarFormat: '只支持png和jpg格式的图片'
  },
  placeholder: {
    username: '请输入姓名',
    position: '请输入职位',
    company: '请输入公司名称',
    personalProfile: '请输入个人简介'
  },
  setting: {
    phoneNumber: '手机号',
    email: '邮箱',
    modifyPassword: '修改密码',
    thirdAccount: '第三方账号',
    about: '关于得帆云',
    logout: '退出登录',
    pleaseInput: '请输入',
    verificationCode: '验证码',
    loginPassword: '登录密码',
    originPassword: '原密码',
    newPassword: '新密码',
    correct: '正确的'
  },
  notice: {
    user: '用户',
    notEmpty: '不能为空',
    getting: '获取中',
    getVerificationCode: '获取验证码',
    pwdLength: '请输入8-32位字母及数字组合'
  },
  about: {
    newFeatures: '功能更新内容',
    serviceProtocol: '用户服务协议',
    copyright: '©上海得帆信息技术有限公司 版权所有',
    version: '版本 '
  },
  thirdAccount: {
    wechat: '微信',
    wechatNickname: '微信昵称',
    bindAccount: '绑定',
    unbindAccount: '解绑'
  }
}
